<script>
  import ApplicationState from "../../../Stores/applicationStates"
  import axios from "axios"
  import Navbar from "../../../Shared/Navbar/index.svelte"
  import Table from "../../../Shared/Table/table.svelte"
  import Footer from "../../../Shared/footer.svelte"
  import List from "./Components/List.svelte"
  import QrCode from "./Components/QRCode.svelte"
  import EmailList from "./Components/emailList.svelte"
  import Stats from "./Components/stats.svelte"
  import LoadingScreen from "../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import notify from "../../../Script/notify"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../Script/queryString"
  import { onDestroy, onMount } from "svelte"
  import DaysDropdown from "../Document/Components/daysDropdown.svelte"
  import AnalyticsFilter from "../Document/Components/analyticsFilter.svelte"
  import { getRequest } from "../../../Script/apiMethods"

  /**
   * @type {Boolean} - for loading screen Show or hide
   */
  let apiCallBtnDisable = false
  /**
   * @type {Boolean} - to show viewed list
   */
  let viewed = true
  /**
   * @type {Boolean} - to show verified list
   */
  let verified = false
  /**
   * @type {Boolean} - to show download list
   */
  let download = false
  /**
   * @type {Object} - to store view, verifed, download, issued count
   */
  let count = {}

  /**
   * @type {Array} - to store document access log list data
   */
  let listData = []
  /**
   * @type {Array} - to store email log list data
   */
  let emailList = []
  /**
   * @type {Number} - to show pagination number for email log table
   */
  let emailListCount = 0
  /**
   * @type {Number} - how many list need to show in doc access log
   */
  let limit

  /**
   * @type {Number} - how many list need to show in email log
   */
  let emailLimit

  /**
   * @type {Number} - which page list need to show in doc access log
   */
  let page
  /**
   * @type {Number} - which page list need to show in email log
   */
  let emailPage

  /**
   * @type {Number} - which order need to show (in order to date) in doc access log
   */
  let sort
  /**
   * @type {Number} - which order need to show (in order to date) in email log
   */
  let emailSort

  /**
   * @type {Object} - object get from window location
   */
  let query = {}

  /**
   * @type {boolean} whether to disable the email button or not
   */
  let disableEmailBtn = false
  /**
   * @type {boolean} whether to show filter component or not
   */
  let showFilterForm = false
  /**
   * @type {boolean} whether to shoiw day dropdown or not
   */
  let daysModel = false
  /**
   * @type {Number} how many days we have to show data
   */
  let days = 7
  /**
   * @type {String} start date for stats
   */
  let startDate = ""
  /**
   * @type {String} end date for stats
   */
  let endDate = new Date(Date.now()).toISOString()
  /**
   * @type {import("../../Publish/BulkUpload/Script/document").bulkDocument}
   */
  let documentData = {}

  /**
   * @type {HTMLElement} - single document dashpoboard page element
   */
  let singleDocDashboradPage

  // this funtion fetch all stat data while page loading
  onMount(async () => {
    try {
      console.log("onMount")

      apiCallBtnDisable = true
      query = queryStringToJSON($querystring)
      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      emailLimit = query.emailLimit ? query.emailLimit : 10
      emailPage = query.emailPage ? query.emailPage : 1
      emailSort = query.emailSort ? query.emailSort : -1
      viewed = query.state == "viewed" ? true : false
      verified = query.state == "verified" ? true : false
      download = query.state == "download" ? true : false
      if (query.state == undefined) viewed = true

      days = query.days ? query.days : 7
      let a = 24 * 60 * 60 * 1000 * days
      let b = new Date().getTime()

      startDate = query.sdate ? query.sdate : new Date(b - a).toISOString()
      endDate = query.edate ? query.edate : new Date(Date.now()).toISOString()
      if (query.sdate) days = "Custom"

      await fetchAllDates()
      if (singleDocDashboradPage) singleDocDashboradPage.scrollIntoView()
    } catch (error) {
      const info = "PAGE: Single Document Analytics\nEVENT: onMount"
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  })

  /**
   * @description Fetched a respective document details from query id
   */
  const fetchDocDetails = async () => {
    try {
      // Fetching document id details
      const { document } = await getRequest(`/api/swagger/v2/documents/${query.id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      documentData = document

      if (!documentData.email) disableEmailBtn = true
    } catch (error) {
      push(`/analytics/documents`)
      throw error
    }
  }

  /**
   * @description Fetch total state count for respective document.
   */
  const fetchDocStat = async () => {
    try {
      // Fetching list of document templates
      const { data } = await axios.get(`/api/analytics/v2/count?doc=${query.id}&sdate=${startDate}&edate=${endDate}`)
      // Check if the response has an error and is not successful
      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }

      count = data
    } catch (error) {
      throw error
    }
  }

  /**
   * @description Data Fetched for email list for respective document.
   */
  const fetchEmailList = async () => {
    try {
      // Fetching document template by ID
      // https://test.swagger.print2block.in/email/stat?sdate=2023-09-01&edate=2023-09-12
      const { data, count } = await getRequest(`/api/analytics/v2/email?doc=${query.id}&limit=${emailLimit}&page=${emailPage}&sort=${emailSort}&sdate=${startDate}&edate=${endDate}`)
      emailList = data
      emailListCount = count
    } catch (error) {
      throw error
    }
  }

  const fetchLogs = async () => {
    try {
      let type
      let state

      if (viewed) {
        type = "view"
        state = "viewed"
      } else if (verified) {
        type = "verify"
        state = "verified"
      } else if (download) {
        type = "download"
        state = "download"
      }

      // Fetching list of document templates
      const { data } = await getRequest(`/api/analytics/v2/${type}?doc=${query.id}&limit=${limit}&page=${page}&sort=${sort}&sdate=${startDate}&edate=${endDate}`)

      listData = data

      push(`/analytics/documents/single?id=${query.id}&limit=${limit}&page=${page}&sort=${sort}&emailLimit=${emailLimit}&emailPage=${emailPage}&emailSort=${emailSort}${!query.sdate ? `&days=${days}` : `&sdate=${startDate}&edate=${endDate}`}&state=${state}`)
    } catch (error) {
      throw error
    }
  }

  /**
   * @description this functions runs when document log table tables entiries are changed (doc table entries).
   */
  const changeTableEntries = async (e) => {
    try {
      apiCallBtnDisable = true
      limit = e.detail.entries ? e.detail.entries : 12
      page = e.detail.activePage ? e.detail.activePage : 1
      sort = e.detail.sort ? e.detail.sort : -1
      await fetchLogs()
    } catch (error) {
      const info = "PAGE: Single Document Analytics\nEVENT: Error occurred during actions such as sorting by date, changing display entries, or navigating pages."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description this functions runs when email log tables entiries are changed (email table entries).
   */
  const changeEmailTableEntries = async (e) => {
    try {
      apiCallBtnDisable = true
      emailLimit = e.detail.entries ? e.detail.entries : 12
      emailPage = e.detail.activePage ? e.detail.activePage : 1
      emailSort = e.detail.sort ? e.detail.sort : -1
      await fetchEmailList()
    } catch (error) {
      const info = "PAGE: Single Document Analytics\nEVENT: Error occurred during actions such as sorting by date, changing display entries, or navigating pages. (Email Logs)"
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description Function to fetch templates based on user input (filter components).
   */
  const whileChangingEntries = async (e) => {
    try {
      page = 1
      days = "Custom"
      apiCallBtnDisable = true
      if (e.detail.startDate) query.sdate = startDate = e.detail.startDate
      if (e.detail.endDate) query.edate = endDate = e.detail.endDate
      await fetchAllDates()
    } catch (error) {
      const info = "PAGE: Single Document Analytics\nEVENT: Error occurred while changing date filter."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description Function to reset the user inputs
   */
  const resetList = async () => {
    try {
      apiCallBtnDisable = true
      limit = 10
      page = 1
      sort = -1
      days = 7
      let a = 24 * 60 * 60 * 1000 * days
      let b = new Date().getTime()
      startDate = new Date(b - a).toISOString()
      endDate = new Date(Date.now()).toISOString()
      query.sdate = ""
      query.edate = ""
      // startDate = "2021-09-07T00:00:00Z"
      // endDate = new Date(Date.now()).toISOString()
      await fetchAllDates()
    } catch (error) {
      const info = "PAGE: Document Analytics\nEVENT: Error occurred during resetting date filter, document access logs or email logs."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description while change the days (7,30,60,90) count this function will run for changing respective dates
   */
  const getDaysToDate = async () => {
    page = 1
    try {
      apiCallBtnDisable = true
      daysModel = false
      let a = 24 * 60 * 60 * 1000 * days
      let b = new Date().getTime()
      startDate = new Date(b - a).toISOString()
      endDate = new Date(Date.now()).toISOString()
      query.sdate = ""
      query.edate = ""
      await fetchAllDates()
    } catch (error) {
      const info = "PAGE: Document Analytics\nEVENT: Error occurred while changing days filter."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   *@description  This function called other all data fetching function
   */
  const fetchAllDates = async () => {
    try {
      await fetchDocDetails()
      await fetchDocStat()
      await fetchEmailList()
      await fetchLogs()
    } catch (error) {
      throw error
    }
  }

  /**
   *@description this intervel checkes every 6 mins all states
   */
  let updateSate = setInterval(() => {
    if (window.location.hash.split("?")[0] == "#/analytics/documents/single") {
      fetchAllDates()
    }
  }, 60000) // i min

  onDestroy(() => {
    clearInterval(updateSate)
  })
</script>

<svelte:head>
  <title>Single Document Analytics</title>
</svelte:head>
<div bind:this={singleDocDashboradPage} class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6">
    <div class="relative mx-auto mb-40 mt-10 h-auto w-full max-w-[920px]">
      <div class="flex items-center justify-between">
        <div class="flex select-none flex-col gap-3 2xl:flex-row 2xl:items-center">
          <h1 class="text-lg font-bold dark:text-white mobile:text-2xl">Single Document Analytics</h1>
          <div class="hidden font-bold text-blue-500 md:block">
            {#if query && query.sdate}
              <!-- ({startDate.slice(0, 16)}) - ({endDate.slice(0, 16)}) -->
              <!-- {new Date(startDate).toUTCString().slice(0, 26)} - {new Date(endDate).toUTCString().slice(0, 26)} -->
              (After) {new Date(new Date(startDate).getTime() - new Date().getTimezoneOffset() * 60000).toUTCString().slice(0, 16)} - (Before) {new Date(new Date(endDate).getTime() - new Date().getTimezoneOffset() * 60000).toUTCString().slice(0, 16)}
            {:else}
              <div class="flex items-center gap-3">
                <span>
                  For last {days} days
                </span>
                <span data-tooltip="(After) {startDate} - (Before) {endDate}" tooltip-position="top">
                  <i class="fa-solid fa-circle-info" />
                </span>
              </div>
            {/if}
          </div>
        </div>
        <div class="relative flex w-3/5 items-center gap-3 mobile:w-fit">
          <DaysDropdown
            dropdownItems={[7, 30, 60, 90]}
            selected={days}
            on:onSelect={(e) => {
              days = e.detail
              getDaysToDate()
            }}
          />
          <AnalyticsFilter on:reset={resetList} on:entriesChanged={whileChangingEntries} />
        </div>
      </div>
      <div class="relative mt-3 min-h-[530px] select-none space-y-12 overflow-hidden rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
        <Stats {count} />
        <QrCode url={{ url: documentData.url, version: documentData.version }} />
        <div class="relative">
          <div class="absolute right-0 top-0 z-10 flex gap-1.5 mobile:gap-3">
            <button
              name="tooltip"
              id="Viewed"
              tooltip-position="top"
              on:click={async () => {
                if (!viewed) {
                  try {
                    apiCallBtnDisable = true
                    viewed = true
                    verified = false
                    download = false
                    // endDate = new Date(Date.now()).toISOString()
                    // await fetchAllDates()
                    await fetchLogs()
                  } catch (error) {
                    const info = "PAGE: Single Document Analytics\nEVENT: While fetching viewed document access log"
                    notify.danger(error, info)
                  } finally {
                    apiCallBtnDisable = false
                  }
                }
              }}
              class="flex items-center rounded-md border {viewed ? 'border-orange-500 bg-orange-500  text-white' : 'border-[#a0a1a580]  bg-transparent  text-gray-800 dark:text-gray-200 dark:hover:text-white'} px-3 py-1 hover:border-orange-600 hover:bg-orange-600 hover:text-white active:bg-orange-400 active:text-white sm:px-3"
            >
              <i class="fa-solid fa-eye" />
              <span class="hidden md:block">&nbsp;&nbsp;Viewed</span>
            </button>
            <button
              name="tooltip"
              id="Verified"
              tooltip-position="top"
              on:click={async () => {
                if (!verified) {
                  try {
                    apiCallBtnDisable = true
                    verified = true
                    viewed = false
                    download = false
                    // endDate = new Date(Date.now()).toISOString()
                    // await fetchAllDates()
                    await fetchLogs()
                  } catch (error) {
                    const info = "PAGE: Single Document Analytics\nEVENT: While fetching verified document access log"
                    notify.danger(error, info)
                  } finally {
                    apiCallBtnDisable = false
                  }
                }
              }}
              class="flex items-center rounded-md border {verified ? 'border-green-500 bg-green-500 text-white' : 'border-[#a0a1a580]  bg-transparent text-gray-800 dark:text-gray-200 dark:hover:text-white'} px-3 py-1 hover:border-green-600 hover:bg-green-600 hover:text-white active:bg-green-400 active:text-white sm:px-3"
            >
              <i class="fa-solid fa-circle-check" />
              <span class="hidden md:block">&nbsp;&nbsp;Verified</span>
            </button>
            <button
              name="tooltip"
              id="Downloaded"
              tooltip-position="top"
              on:click={async () => {
                if (!download) {
                  try {
                    apiCallBtnDisable = true
                    viewed = false
                    verified = false
                    download = true
                    // endDate = new Date(Date.now()).toISOString()
                    // await fetchAllDates()
                    await fetchLogs()
                  } catch (error) {
                    const info = "PAGE: Single Document Analytics\nEVENT: While fetching downloaded document access log"
                    notify.danger(error, info)
                  } finally {
                    apiCallBtnDisable = false
                  }
                }
              }}
              class="flex items-center rounded-md border {download ? 'border-sky-500 bg-sky-500 text-white' : 'bg-transparent  text-gray-800 dark:text-gray-200 dark:hover:text-white'}  px-3 py-1 hover:border-sky-600 hover:bg-sky-600 hover:text-white active:bg-sky-400 active:text-white sm:px-3"
            >
              <i class="fa-solid fa-circle-down" />
              <span class="hidden md:block">&nbsp;&nbsp;Downloaded</span>
            </button>
          </div>
          <Table on:changeEntries={changeTableEntries} on:resetEntries={resetList} title="Document<br/> access Log" bind:activePage={page} jsonData={listData} count={viewed ? count.view : verified ? count.verify : download ? count.download : 0} search={false} nameSort={false}>
            {#if listData.length}
              {#each listData as json}
                <List {json} />
              {/each}
            {:else}
              <div class="text-secondary2 select-none rounded-md bg-[#f7f7f7] py-6 text-center text-2xl dark:bg-bodyblack dark:text-white">There is no document access log</div>
            {/if}
          </Table>
        </div>

        <div class="relative">
          <button
            on:click={() => {
              push(`/analytics/documents/send-email?id=${query.id}`)
            }}
            class="absolute top-0 right-0 z-10 float-right flex h-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-400 disabled:cursor-not-allowed disabled:bg-blue-500/50 sm:ml-3 sm:w-auto"
          >
            <i class="fa-solid fa-envelope" />
            <span>&nbsp;&nbsp;{emailList.length ? "Resend" : "Send"} email</span>
          </button>
          <Table on:changeEntries={changeEmailTableEntries} on:resetEntries={resetList} title={"Email Log"} jsonData={emailList} count={emailListCount} search={false} nameSort={false}>
            {#if emailList.length}
              {#each emailList as json}
                <EmailList {json} />
              {/each}
            {:else}
              <div class="text-secondary2 select-none rounded-md bg-[#f7f7f7] py-6 text-center text-2xl dark:bg-bodyblack dark:text-white">There is no email log</div>
            {/if}
          </Table>
        </div>
      </div>
      {#if apiCallBtnDisable}
        <LoadingScreen msg={"Fetching document analytics"} />
      {/if}
    </div>
  </div>
  <Footer />
</div>
